import { render, staticRenderFns } from "./LinkInputSettings.vue?vue&type=template&id=53eb0dd2&"
import script from "./LinkInputSettings.vue?vue&type=script&lang=ts&"
export * from "./LinkInputSettings.vue?vue&type=script&lang=ts&"
import style0 from "./LinkInputSettings.vue?vue&type=style&index=0&id=53eb0dd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports